:host {
  display: block;
}

:host([type='compact']:not([disabled]):first-of-type) {
  border-top: 1px solid var(--o2-border-primary, #{$border-primary});
}

:host([type="box"]:not(:first-of-type)) {
  margin-top: $spacing-3;
}

.dropdown {
  transition-timing-function: var(--o2-transition);
  transition-duration: 0.2s;
   background: var(--o2-background-main-primary, #{$background-main-primary});

  &.dropdown--border-left {
    border-left-style: solid;
    border-left-width: 0.5rem;

    .dropdown__header {
      padding-left: 1.6rem;
    }

    .dropdown__content {
      padding-left: 1.6rem;
    }
  }

  &.dropdown--border-primary {
    border-left-color: var(--o2-blue-action, #{$blue-action});
  }

  &.dropdown--border-success {
    border-left-color: var(--o2-green, #{$green});
  }

  &.dropdown--border-warning {
    border-left-color: var(--o2-orange, #{$orange});
  }

  &.dropdown--border-danger {
    border-left-color: var(--o2-red, #{$red});
  }

  .dropdown__header {
    position: relative;
    padding: 1rem 1.6rem;
    transition: 0.2s ease;
    text-decoration: none;
    cursor: pointer;
    display: flex;
    align-items: center;
    gap: $spacing-4;

    &:hover {
      background: $background-main-hover
    }

    .dropdown__heading,
    slot[name='heading']::slotted(*) {
      color: var(--o2-main-text-primary, #{$text-main-primary});
      font-size: 1.6rem;
      color: var(--o2-main-text-primary, #{$text-main-primary});
      font-style: normal;
      line-height: 1.3;
      flex-grow: 1;
      @include font-weight(600);
    }

    .dropdown__heading-right {
      font-size: 1.6rem;
      color: var(--o2-main-text-primary, #{$text-main-primary});
      line-height: 1.3;
      @include font-weight(600);
      font-style: normal;
    }

    .dropdown__icon {
      transition-timing-function: var(--o2-transition);
      transition-duration: 0.2s;
      line-height: 1;
      flex-shrink: 0;
    }
  }

  .dropdown__content {
    padding: 0 1.6rem;
    visibility: hidden;
    overflow: hidden;
    opacity: 1;
    max-height: 0;
    transition: all 0.15s ease-out;
  }

  &.dropdown--open {
    .dropdown__heading,
    slot[name='heading']::slotted(*) {
      color: var(--o2-main-text-primary, #{$text-main-primary});
    }

    .dropdown__icon {
      transform: rotate(180deg);
    }

    .dropdown__content {
      padding: 1.6rem 1.6rem 2.4rem 1.6rem;
      visibility: visible;
      overflow: visible;
      opacity: 1;
      max-height: 100%;
      transition: all 0.25s ease-in-out;
    }
  }
}

.dropdown--compact {
  border-bottom: 1px solid var(--o2-border-primary, #{$border-primary});
}

/* Dropdown type box styles */
.dropdown--box {

  .dropdown__header {
    border-top-right-radius: var(--border-radius, #{$border-radius});
    border-top-left-radius: var(--border-radius, #{$border-radius});
  }

  .dropdown__content {
    border-bottom-left-radius: var(--border-radius, #{$border-radius});
    border-bottom-right-radius: var(--border-radius, #{$border-radius});
  }
}

.dropdown--summary {
  border-bottom: 1px solid var(--o2-border-primary, #{$border-primary});

  .dropdown__header {
    padding: 1rem 1.6rem;
  }

  .dropdown__icon {
    color: var(--o2-blue-action, #{$blue-action});
  }

  .dropdown__icon:hover {
    color: var(--o2-blue-action-dark, #{$blue-action-dark});
  }

  &.dropdown--open .dropdown__heading {
    color: var(--o2-main-text-primary, #{$text-main-primary});
  }
}

.dropdown--disabled {
  border: 0;

  .dropdown__header {
    cursor: auto;

    &:hover {
      background: none
    }
  }
}
